var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSouthKorea(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#f0f0f0",
    r: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m345.043 256c0 22.261-39.866 77.913-89.043 77.913s-89.043-55.652-89.043-77.913c0-49.178 39.866-89.043 89.043-89.043s89.043 39.865 89.043 89.043z",
    fill: "#d80027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m345.043 256c0 49.178-39.866 89.043-89.043 89.043s-89.043-39.865-89.043-89.043",
    fill: "#0052b4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m353.427 319.639h33.391v22.261h-33.391z",
    transform: "matrix(.707 -.707 .707 .707 -125.483 358.596)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m314.07 358.994h33.391v22.261h-33.391z",
    transform: "matrix(.707 -.707 .707 .707 -164.839 342.294)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m400.656 366.851h33.391v22.261h-33.391z",
    transform: "matrix(.707 -.707 .707 .707 -145.034 405.821)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m361.299 406.213h33.391v22.261h-33.391z",
    transform: "matrix(.707 -.707 .707 .707 -184.394 389.52)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m377.04 343.247h33.391v22.261h-33.391z",
    transform: "matrix(.707 -.707 .707 .707 -135.26 382.208)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m337.694 382.602h33.391v22.261h-33.391z",
    transform: "matrix(.707 -.707 .707 .707 -174.613 365.913)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m329.544 126.805h89.043v22.261h-89.043z",
    transform: "matrix(-.707 -.707 .707 -.707 541.034 499.974)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m314.081 130.749h33.391v22.26h-33.391z",
    transform: "matrix(-.707 -.707 .707 -.707 464.348 476.098)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m353.427 170.098h33.391v22.26h-33.391z",
    transform: "matrix(-.707 -.707 .707 -.707 503.692 571.091)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m361.282 83.526h33.391v22.261h-33.391z",
    transform: "matrix(-.707 -.707 .707 -.707 578.316 428.859)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m400.651 122.879h33.391v22.261h-33.391z",
    transform: "matrix(-.707 -.707 .707 -.707 617.695 523.876)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m69.81 386.542h89.043v22.261h-89.043z",
    transform: "matrix(.707 .707 -.707 .707 314.684 35.631)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m140.919 382.6h33.391v22.26h-33.391z",
    transform: "matrix(.707 .707 -.707 .707 324.573 3.87)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m101.569 343.252h33.391v22.261h-33.391z",
    transform: "matrix(.707 .707 -.707 .707 285.225 20.171)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m117.031 339.316h89.043v22.261h-89.043z",
    transform: "matrix(.707 .707 -.707 .707 295.121 -11.592)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m69.81 103.201h89.043v22.261h-89.043z",
    transform: "matrix(-.707 .707 -.707 -.707 276.02 114.331)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m93.412 126.806h89.043v22.261h-89.043z",
    transform: "matrix(-.707 .707 -.707 -.707 333.003 137.938)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m117.038 150.428h89.043v22.26h-89.043z",
    transform: "matrix(-.707 .707 -.707 -.707 390.037 161.557)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthKorea);
export default __webpack_public_path__ + "static/media/southKorea.d5cb06b9e3cf10dc519ecb32436be9ad.svg";
export { ForwardRef as ReactComponent };